import React from 'react';
import { useHistory } from 'react-router';

import { Container } from './styles';

function MenuList({ title, links, isHorizontal }) {
  const { push } = useHistory();

  const handleItemClick = to => {
    push(process.env.PUBLIC_URL + '/' + to);
  };

  return (
    <Container isHorizontal={isHorizontal}>
      {title && <h5 className="title">{title}</h5>}

      <div className="links">
        {links.map(item => (
          <span
            key={`${item.to}${item.text}`}
            className="item"
            onClick={() => handleItemClick(item.to)}
          >
            {item.text}
          </span>
        ))}
      </div>
    </Container>
  );
}

export default MenuList;
